<script>
import { useCourseFetchStore } from "@/stores/course/course-fetch-store";
import { useEnrollmentStore } from "@/stores/access/enrollment-store";
import { useUserStore } from "@/stores/user/user-store";
import { useAuthStore } from "@/stores/auth-store";
import { onMounted, watch } from "vue";

export default {
  setup() {
    const courseFetchStore = useCourseFetchStore();
    const userStore = useUserStore();
    const authStore = useAuthStore();
    const enrollmentStore = useEnrollmentStore();

    onMounted(() => {
      courseFetchStore.fetchGroupList();
      courseFetchStore.fetchDifficultyList();
      courseFetchStore.fetchStatusList();
      userStore.fetchTeachers();
      enrollmentStore.fetchEnrollmentStudentList(authStore.currentUser.id);
      enrollmentStore.fetchEnrollmentStatusList();
    });
    return { courseFetchStore, authStore, userStore, enrollmentStore };
  },
  methods: {
    toggleFilterDifficulties(difficulty) {
      const index =
        this.courseFetchStore.filterDifficulties.indexOf(difficulty);
      if (index === -1) {
        this.courseFetchStore.filterDifficulties.push(difficulty);
      } else {
        this.courseFetchStore.filterDifficulties.splice(index, 1);
      }
    },
    toggleFilterInstructor(instructor) {
      const index = this.courseFetchStore.filterInstructor.indexOf(instructor);
      if (index === -1) {
        this.courseFetchStore.filterInstructor.push(instructor);
      } else {
        this.courseFetchStore.filterInstructor.splice(index, 1);
      }
    },
    toggleFilterGroup(groupCode) {
      const index = this.courseFetchStore.filterGroup.indexOf(groupCode);
      if (index === -1) {
        this.courseFetchStore.filterGroup.push(groupCode);
      } else {
        this.courseFetchStore.filterGroup.splice(index, 1);
      }
    },
    toggleFilterGroup(status) {
      const index = this.courseFetchStore.filterStatus.indexOf(status);
      if (index === -1) {
        this.courseFetchStore.filterStatus.push(status);
      } else {
        this.courseFetchStore.filterStatus.splice(index, 1);
      }
    },
    clearFilters() {
      this.enrollmentStore.clearAllFilters();
    },
  },
};
</script>

<template>
  <div class="modal fade" id="filterStudentCourseModal">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Filter Course</h5>
          <button
            type="button"
            class="btn-close custom-btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          >
            <i class="isax isax-close-circle5"></i>
          </button>
        </div>

        <div class="modal-body">
          <!-- Group Filter -->
          <label class="form-label">Group Code</label>
          <vSelect
            multiple
            class="vselect-custom mb-3"
            v-model="enrollmentStore.filterGroup"
            :options="courseFetchStore.groupList"
            :reduce="(option) => option.course_group_id"
            label="code"
            placeholder="Select Group"
          />

          <!-- Difficulty Filter -->
          <label class="form-label">Difficulty</label>
          <vSelect
            multiple
            class="vselect-custom mb-3"
            v-model="enrollmentStore.filterDifficulties"
            :options="courseFetchStore.difficultyList"
            label="name"
            placeholder="Select Difficulty"
          />

          <!-- Instructor Filter -->
          <label class="form-label">Instructor</label>
          <vSelect
            multiple
            class="vselect-custom mb-3"
            v-model="enrollmentStore.filterInstructor"
            :options="userStore.ActiveTeachers"
            placeholder="Select Instructor"
            :reduce="(user) => user.userID"
            :get-option-label="(user) => authStore.userName(user.userID)"
          />
          <label class="form-label">Status</label>
          <vSelect
            multiple
            class="vselect-custom mb-3"
            v-model="enrollmentStore.filterStatus"
            :options="enrollmentStore.enrollmentStatusList"
            placeholder="Select Status"
          />
        </div>

        <div class="modal-footer">
          <button @click="clearFilters" class="btn btn-secondary">Clear</button>
        </div>
      </div>
    </div>
  </div>
</template>
